import script from "./WordsListDlg.vue?vue&type=script&setup=true&lang=js"
export * from "./WordsListDlg.vue?vue&type=script&setup=true&lang=js"

import "./WordsListDlg.vue?vue&type=style&index=0&id=9300d87e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9300d87e"]])

export default __exports__